import { render } from "./LuckyRewardsLastWeek.vue?vue&type=template&id=493f632c"
import script from "./LuckyRewardsLastWeek.vue?vue&type=script&lang=js"
export * from "./LuckyRewardsLastWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__